import { Action, createAction, handleActions } from 'redux-actions'

export interface ILoadingState {
  [key: string]: boolean
}

export const LOADING = 'CommonLoading'

export const START_LOADING = `${LOADING}/START_LOADING`
export const FINISH_LOADING = `${LOADING}/FINISH_LOADING`

export const loadingActions = {
  start: createAction<string>(START_LOADING),
  finish: createAction<string>(FINISH_LOADING),
}

const initialState = {}

export const reducer = {
  [START_LOADING]: (state: ILoadingState, action: Action<string>) => ({
    ...state,
    [action.payload]: true,
  }),
  [FINISH_LOADING]: (state: ILoadingState, action: Action<string>) => ({
    ...state,
    [action.payload]: false,
  }),
}

export const loadingReducer = handleActions(reducer, initialState)
